angular.module('festzelt-os.modules.rsvps', [
    'festzelt-os.components'
]);

require('./components');

require('./helpers/status-email-helper');



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/module.js